export default __webpack_public_path__ + "static/media/placeholderTN.png";